import "./Contact.scss";
import { ContactForm, ContactFormRef } from "components";
import { IContactFormValidation } from "components/Contact/ContactForm/ContactForm.config";
import { useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useCreateContactMutation } from "state/api/landingApi";

export const Contact = () => {

  const [createContact, { isLoading, isSuccess, isError }] = useCreateContactMutation();

  const formRef = useRef<ContactFormRef>(null);

  const onCompletedFormHandler = (values: IContactFormValidation) => {
    createContact(values);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success("Mensaje enviado");
      formRef.current?.resetValues();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      toast.success("Ha habido algún problema enviando el mensaje");
    }
  }, [isError, formRef]);

  return (
    <div className="contact-container">
      <ToastContainer />
      <div className="scale-your-bussiness">
        <div>
          <span className="text-title">Contáctanos desde aqui</span>
        </div>
      </div>
      <div className="contact-form">
        <span className="text-title">Envíanos un mensaje</span>
        <p>Rellena los siguientes datos:</p>
        <div>
          <ContactForm ref={formRef} isLoading={isLoading} onCompletedForm={onCompletedFormHandler} />
        </div>
      </div>
    </div>
  );
};